export class FileUploadFile {
    public id!: string;
    public name!: string;
    public content!: string;
}
